import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { forkJoin, Observable, Subscription } from 'rxjs';
import swal2 from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { CreditosService } from '../../services/creditos/creditos.service';
import { ListasService } from '../../services/listas/listas.service';
import { AwsService } from '../../services/awsser/aws.service';
import { ReportesService } from '../../services/reportes/reportes.service';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
declare var $;
import * as fs from 'file-saver';
import { DatePipe } from '@angular/common';
import { ContribuyentesService, UsuarioService } from 'src/app/services/service.index';
import * as XLSX from 'xlsx';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-aprobar-creditos',
  templateUrl: './aprobar-creditos.component.html',
  styleUrls: ['./aprobar-creditos.component.scss']
})
export class AprobarCreditosComponent implements OnInit {
  @ViewChild('dt') dt: Table;
  uploadForm: FormGroup;
  fileName = 'Layout.xlsx';
  facturas: any[] = [];
  url: any;
   calificacionBC:any;
  file: any;
  datosdetalles: any[] = [];
  selectedSol: any[] = [];
  cols: any[] = [];
  solicitudes: any[] = [];
  estatussolicitudes: any[] = [];
  usuarios: any[] = [];
  idu: string;
  documentonulo: boolean;
  uploadURL: Observable<string>;
  uploadProgress: Observable<number>;
  showModal: boolean = false;
  showmodalds: boolean;
  idsolicitud: string;
  foliosolicitud: string;
  carpeta: string;
  nombrearchivosubido: string;
  estatus1: string;
  estatusburo: string;
  estatusindice: string;
  estatuspayment: string;
  estatusflow: string;
  notes = '';

  calificaciones = [];
  requests = [];
  terms = [];
  paymentPeriods = [];
  intereses = 16;
  colDetallesCustomer = [];
  idRechazo = '';
  ngSelect = '';
  urlburo = '';

  creditos = [];
  rates = [];
  ivaRates = [];
  anuality_date = [];
  payments = [];
  documents = [];
  regimen_fiscal = [];
  regimen_fiscal_contribuyente = [];
  client_status = [];
  filtro = 'SO';
  credit_status = [];
  datosEmpleado = {
    gov_customer_id: null,
  };
  resumen_creditos = [];
  creditos_buro = [];
  buro: string;
  analysis: string;
  buroStatus = false;
  analysisStatus = false;
  stepBuro = false;
  rfcBC = '';
  scoreBC = '';
  fechaReporte = '';
  saldosVencidos = '';
  accured_liabilities = '';
  anual_rate = '';
  balance_due = '';
  car_credit = '';
  car_creditnum = 0;
  cash_flow = 'Dato no capturado';
  created_at = '';
  analisis_credit_status = '';
  credit_type = '';
  customer_credit_id = '';
  customer_number = '';
  debt = '';
  debtnum = 0;
  debt_horizon = 'Dato no capturado'; 
  debt_rate = 'Dato no capturado';
  departamental_credit = '';
  discounts = 'Dato no capturado';
  extra_incomes = '';
  extra_deductions = '';
  id = '';
  last_key = '';
  lowest_key = '';
  mop_key = '';
  mortagage_loan = 'Dato no capturado';
  mortagage_loannum = 0;
  net_flow = 'Dato no capturado';
  net_flownum = 0;
  other_credits = '';
  overall_rate = '';
  payment_capacity = '';
  previus_credit = '';
  report_date = '';
  total_amount = '';
  total_cost = '';
  total_debt = '';
  ingresos_netos = "";
  ingresos_netosnum = 0;
  egresos_netos = '';
  egresos_netosnum = 0;
  gastos_familiares = '';
  gastos_familiaresnum = 0;
  renta_casa = '';
  renta_casanum = 0;
  creditos_CP = '';
  creditos_CPnum = 0;
  creditos_LP = '';
  creditos_LPnum = 0;
  periodo_pago = '';
  pdf:any;
  creditoSeleccionadoTabla = {};
  maritalStatus: any;
  lists = [];
  regimen_fiscal2 = [];
  cus = {};
  detail_extra_income = [];
  detail_extra_deductions = [];
  garantia = {
    guarantee_object: '',
    guarantee_object_address: '',
    guarantee_email: '',
    guarantee_extra: '',
  }
  garantiaModal = false;
  companies = [];
  credito = {};
  payment_capacitym: number;
  payment_capacity_percentage: number;
  muestro = false;
  analystUsers: any[] = [];
  refinanciamientoItems = [];
  
  constructor(private _formBuilder: FormBuilder,
              public router: Router,
              private route: ActivatedRoute,
              private creditosService: CreditosService,
              private formBuilder: FormBuilder, private httpClient: HttpClient,
              private listasService: ListasService,
              private awsService: AwsService,
              private reportesService: ReportesService ,
              private sanitizer: DomSanitizer,
              private usuarioService: UsuarioService,
              private contribuyenteService: ContribuyentesService
              ) {}

  ngOnInit() {
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
    });
    swal2.showLoading();
    this.muestro = false;
    this.analystUsers = [];
    this.awsService.getAdminAnalystUsers().subscribe(resp => {
      this.analystUsers = resp;
    });
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    const estatus: any = document.getElementById('estatus');
    this.selectedSol = [];
    this.idu = localStorage.getItem('uid'); 
    this.cols = [
      { field: 'credit_folio', header: 'Folio', moneda: false },
      { field: 'created_at', header: 'Fecha solicitud', moneda: false },
      { field: 'start_date', header: 'Fecha Inicio', moneda: false },
      { field: 'nombre_empleado', header: 'Nombre Empleado', moneda: false },
      { field: 'compañia', header: 'Compañía', moneda: false },
      { field: 'interests', header: 'Intereses', moneda: true },
      { field: 'commission1', header: 'Comisión', moneda: true },
      { field: 'insurance1', header: 'Seguro', moneda: true },
      { field: 'rate', header: 'Tasa', moneda: false },
      { field: 'total_debt', header: 'Adeudo Total', moneda: true },
      { field: 'total_requested', header: 'Pedido Total', moneda: true },
      { field: 'fixed_payment', header: 'Pago Fijo', moneda: true },
      { field: 'term', header: 'Plazo', moneda: false },
      { field: 'payment_period', header: 'Periodicidad', moneda: false },
      { field: 'has_guarantee_object', header: 'Grarantía', moneda: false },
      { field: 'analyst_name', header: 'Analista', moneda: false },
    ];
    this.creditos = [];
    this.anuality_date = [];
    this.regimen_fiscal = [];
    this.regimen_fiscal_contribuyente = [];
    this.client_status = [];
    this.credit_status = [];
    this.maritalStatus = [];
    this.regimen_fiscal2 = [];
    this.rates = [];
    this.ivaRates = [];
    this.paymentPeriods = [];
    forkJoin({
    listas: this.listasService.getLists(),
    tasas: this.creditosService.ext_rates(),
    condiciones: this.creditosService.getCondiciones(),
    periodos: this.creditosService.getperiodosPagos(),
    creditos: this.creditosService.getCredits()
  }).subscribe(async ({ listas, tasas, condiciones, periodos, creditos }) => {
    //listas
    listas['data'].forEach(list => {
        if(list['attributes'].domain === 'ANUALITY_DATE'){
          this.anuality_date.push(list['attributes']);
        }
        else if(list['attributes'].domain === 'PERSON_FISCAL_REGIME'){
          this.regimen_fiscal.push(list['attributes']);
        }
        else if(list['attributes'].domain === 'CONTRIBUTOR_FISCAL_REGIME'){
          this.regimen_fiscal_contribuyente.push(list['attributes']);
        }
        else if(list['attributes'].domain === 'CLIENT_STATUS'){
          this.client_status.push(list['attributes']);
        }
        else if(list['attributes'].domain === 'CREDIT_STATUS'){
          this.credit_status.push(list['attributes']);
        }
      });
    listas['data'].forEach(list => {
        this.lists.push(list.attributes);
      });
    this.maritalStatus = this.lists.filter(p => p.domain === 'PERSON_MARTIAL_STATUS');
    this.regimen_fiscal2 = this.lists.filter(p => p.domain === 'CONTRIBUTOR_FISCAL_REGIME');
    //tasas
    tasas['data'].forEach(rate => {
        if(rate.attributes.rate_type === 'TA'){
          this.rates.push(rate.attributes);
        }else if(rate.attributes.rate_type === 'IVA'){
          this.ivaRates.push(rate.attributes);
        }
      });
    //condiciones
    this.terms = condiciones;
    //periodos
    this.paymentPeriods = periodos;
    this.paymentPeriods.push({id:'0', key:'Pago Fijo'});
    //creditos
    const creditosFiltrados = creditos['data'].filter(item => item.attributes.status === this.filtro);
    for (const item of creditosFiltrados) {
      item.attributes.analyst_user = item.analyst_user || null;
      await this.armarCreditosAsync(item.attributes);
    }
    this.creditos.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    this.muestro = true;
    setTimeout(() => {
      this.dt.reset();
    });
  swal2.close();
  }, error => {
      console.error(error);
      swal2.close();
      swal2.fire('Error', 'Ocurrió un error al cargar los datos.', 'error');
    });
  }

  get mostrarFormulario(): boolean {
    return !this.showModal && 
           this.datosEmpleado?.gov_customer_id &&
           this.credito && 
           Object.keys(this.credito).length > 0;
  }

  detalleGarantia(rowData){
    Object.keys(this.garantia).forEach(k => {
      this.garantia[k] = rowData[k];
    })
    console.log(this.garantia)
    this.garantiaModal = true;
  }

  cerrarGarantia(){
    Object.keys(this.garantia).forEach(k => {
      this.garantia[k] = '';
    })
    this.garantiaModal = false;
  }

  getDocuments(id_contribuyente){
    this.awsService.getUserDocuments(id_contribuyente).subscribe(docs => {
      this.documents = [];
      docs['data'].forEach(doc => {
        if(doc.attributes.name == "Comprobantes de ingresos del empleado"){
          var arrayUrl = doc.attributes.url.split('*');
          arrayUrl.forEach(url => {
            if(url != ''){
              let params = {
                contributor_id: doc.attributes.contributor_id,
                created_at: doc.attributes.created_at,
                extra1: null,
                extra2: null,
                extra3: null,
                file_type_document_id: doc.attributes.file_type_document_id,
                id: doc.attributes.id,
                name: doc.attributes.name,
                notes: null,
                status: doc.attributes.status,
                updated_at: doc.attributes.updated_at,
                url: url
              }
              let variable = doc.attributes;
              variable.url = url;
              this.documents.push(params);
            }
          });
        }else{
          this.documents.push(doc.attributes);
        }
        /* if(doc.attributes.name != "Comprobantes de ingresos del empleado"){
          if(doc.attributes.url){

            this.documents.push(doc.attributes);
          }
        }else{
          var arrayUrl = doc.attributes.url.split('*');
          arrayUrl.forEach(url => {
            if(url != ''){
              doc.attributes.url = url;
              this.documents.push(doc.attributes);
            }
          });
        } */
      });
      if(this.buroStatus){
        if(this.buro['extra1'] != null){
          this.documents.push({'url': this.buro['extra1'], 'name': 'Reporte Buró de Crédito'});
        }
      }
        /* if(this.datosEmpleado['reporte_final'] && this.datosEmpleado['reporte_final'] !== null){
          this.documents.push({'url': this.datosEmpleado['reporte_final'], 'name': 'Expediente firmado'});
        }else if(this.datosEmpleado['extra1'] && this.datosEmpleado['extra1'] !== null && this.datosEmpleado['extra1'] !== undefined){console.log(this.datosEmpleado['extra1'])
          this.documents.push({'url': this.datosEmpleado['extra1'], 'name': 'Expediente'});
        }   */      
    })
  }

  dragEnter(id: string) {
    document.getElementById(id).style.border = "dashed 3px #73CB38";
  }
  dragLeave(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }
  drop(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }

  async fileBrowseHandler( event: any, doc: string ) {
      const file: File = event.target.files[0];

      const imgExtensiones = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/svg+xml'
      ];

      if(doc == 'firma'){
        if (file && !imgExtensiones.includes(file.type)) {
          swal2.fire('Atención', 'Solo se permiten imágenes (PNG, JPG, JPEG, etc.)', 'info');
          event.target.value = '';
          return;
        }
      }

      if(doc == 'firmado'){
        if (file && file.type !== 'application/pdf') {
          swal2.fire('Atención', 'Solo se permiten archivos PDF', 'info');
          event.target.value = ''; // Limpia el input
          return;
        }
      }

      await this.callupload(file, doc);
    }
  
    async callupload(file, doc) {
      try {
        const r = await this.awsService.uploadFileSB(file, this.credito['id']);
        console.log(r);
        var param = {};
        if(doc == 'firmado'){
          param = {attached: r['url']}
        }else if(doc == 'firma'){
          param = {photography: r['url']}
        }
        (await this.creditosService.updateCredit(this.credito['id'], param)).toPromise().then(resp => {
          if(doc == 'firmado'){
            this.credito['attached']= r['url']
          }else if(doc == 'firma'){
            this.credito['photography']= r['url']
          }
        });
      } catch (error) {
        console.log('error', error);
        let resp = {
          status: false,
          resp: error,
          msg: 'Fallo al subir archivo'
        }
        try{
          swal2.fire(error.error.error, error.error.exception, 'info');
        }catch{
          swal2.fire('Error', 'Ocurrió algo en la carga', 'info')
        }
        return resp
      }
    }

  async detalleClienteGov(customer, person, contributor_address, contributor, gov_actual_job, rowData){
    this.datosEmpleado = {
      gov_customer_id: null
    };
    console.log('rowData', rowData); 
    this.credito = rowData;
    console.log('credito', this.credito); 
    if(this.credito['refinancing']){
      this.consultaRefinanciamiento(this.credito['id']);
    }
    this.datosEmpleado = person;
    Object.assign(this.datosEmpleado, customer);
    Object.assign(this.datosEmpleado, contributor);
    Object.assign(this.datosEmpleado, contributor_address);
    Object.assign(this.datosEmpleado, gov_actual_job);
    this.datosEmpleado['dependientes'] = parseInt(person['senior_dependents']) + parseInt(person['minior_dependents'])
    this.datosEmpleado['martial_status_value'] = this.maritalStatus.find(m => m.key == person['martial_status']).value;
    this.datosEmpleado['fiscal_regime_value'] = this.regimen_fiscal2.find(r => r.key == person['fiscal_regime']).value;
    this.datosEmpleado['salary_period'] = customer['salary_period'].toUpperCase();
    if(this.datosEmpleado['salary_period'] == 'QUINCENAL'){
      this.datosEmpleado['month_salary'] = (parseFloat(this.esNulo(customer['salary'])) * 2).toFixed(2);
    }else if(this.datosEmpleado['salary_period'] == 'SEMANAL'){
      this.datosEmpleado['month_salary'] = (parseFloat(this.esNulo(customer['salary'])) * 4.33).toFixed(2);
    }
    this.datosEmpleado['immediate_superior'] = this.datosEmpleado['direct_boss'];
    this.datosEmpleado['other_income'] = this.datosEmpleado['extra_income'];
    this.contribuyenteService.getcompany(this.datosEmpleado['company_id']).subscribe(resp => {
      this.datosEmpleado['business_name'] = resp['data']['attributes']['business_name'];
    });
    // var p = terms.find(t => t.id == this.credito['term_id']);
    // this.plazo = p.key + ' ' + p.term_type;
    this.payment_capacity_percentage = ((parseFloat(rowData['customer']['relations']['gov_customers'][0]['attributes']['extra_expenses']) + parseFloat(rowData['customer']['relations']['gov_customers'][0]['attributes']['expenses'])) * 100) / (parseFloat(rowData['customer']['relations']['gov_customers'][0]['attributes']['salary']) + parseFloat(rowData['customer']['relations']['gov_customers'][0]['attributes']['extra_income']));
    this.payment_capacitym = (parseFloat(rowData['customer']['relations']['gov_customers'][0]['attributes']['salary']) + parseFloat(rowData['customer']['relations']['gov_customers'][0]['attributes']['extra_income'])) * 0.3;
    this.getDocuments(contributor.id);
    this.showmodalds = true;
  }

  consultaRefinanciamiento(id){
    this.creditosService.getFinDetailsbycustomerCredit(id).subscribe(resp => {
      console.log('el refinanciamiento', resp)
      this.refinanciamientoItems = JSON.parse(JSON.stringify(resp));
      this.refinanciamientoItems.forEach(r => {
        r['financiera'] = this.companies.find(c => c.id == r.company_id).business_name;
      })
    })
  }
  
  async detalleCliente(rowData) {
    let customer;
    if(rowData.gov_customer_id && rowData.gov_customer_id != null){
      customer = rowData.customer.relations.gov_customers[0].attributes; 
      let person = rowData.customer.attributes; 
      let contributor_address = rowData.customer.relations.contributor_addresses[0].attributes;
      let contributor = rowData.customer.relations.contributors[0].attributes;
      let gov_actual_job = rowData.customer.relations.gov_actual_job[0].attributes;
      this.detalleClienteGov(customer, person, contributor_address, contributor, gov_actual_job, rowData);
    }else{
      console.log("NO ENTRO")
      customer = rowData.customer;
      this.showmodalds = true;
      this.datosEmpleado = {
        gov_customer_id: null
      };
      this.egresos_netos = rowData.customer.egresos_netos;
      if (!rowData.customer.gastos_familiares){
          this.gastos_familiares = this.formatNumber(this.esNulo(parseFloat('2500').toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
          this.gastos_familiaresnum = parseFloat('2500');
        } else if(rowData.customer.gastos_familiares == 0 ) {
          this.gastos_familiares = this.formatNumber(this.esNulo(parseFloat(rowData.customer.gastos_familiares).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2})) + 2500;
          this.gastos_familiaresnum = parseFloat(rowData.customer.gastos_familiares) + 2500;
        } else{
        this.gastos_familiares = this.formatNumber(this.esNulo(parseFloat(rowData.customer.gastos_familiares).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
        this.gastos_familiaresnum = parseFloat(rowData.customer.gastos_familiares)
      }
  
      this.renta_casa = this.formatNumber(this.esNulo(parseFloat(rowData.customer.renta).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
      this.creditos_CP = this.formatNumber(this.esNulo(parseFloat(rowData.customer.creditos_cp).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
      
      this.renta_casanum = parseFloat(rowData.customer.renta)
      this.creditos_CPnum = parseFloat(rowData.customer.creditos_cp)
      this.creditos_LPnum = parseFloat(rowData.customer.creditos_lp)
      this.periodo_pago = this.formatNumber(this.esNulo(parseFloat(rowData.customer.periodo_pago).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
      // this.datosdetalles = [];
      // this.datosdetalles.push(rowData.customer);
      
      this.creditosService.tiene_analisis(rowData.customer).subscribe(analysis => {
        this.analysisStatus = analysis.status;
        if (this.analysisStatus){
          this.analysis = analysis.credit_analysis;
          this.accured_liabilities = this.analysis[0]['accured_liabilities']
          this.debt_horizon = this.analysis[0]['debt_horizon']
          this.anual_rate = this.analysis[0]['anual_rate'];
          this.balance_due = this.analysis[0]['balance_due'];
          this.car_credit = this.analysis[0]['car_credit'];
          this.notes = this.analysis[0]['notes'];
          this.car_creditnum = parseFloat(this.analysis[0]['car_credit']);
          this.credit_status = this.analysis[0]['credit_status'];
          this.cash_flow = this.analysis[0]['cash_flow'];
          if(parseFloat(this.cash_flow) >= 80 && parseFloat(this.cash_flow) <= 100 ){
            this.estatusflow = "check"
          }else if(parseFloat(this.cash_flow) >= 101 && parseFloat(this.cash_flow) <= 110){
            this.estatusflow = "priority_high"
          }else{
            this.estatusflow = "close"
          }
          this.created_at = this.analysis[0]['created_at'];
          this.analisis_credit_status = this.analysis[0]['credit_status'];
          this.credit_type = this.analysis[0]['credit_type'];
          this.customer_credit_id = this.analysis[0]['customer_credit_id'];
          this.customer_number = this.analysis[0]['customer_number'];
          this.debt = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['debt']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
          this.debtnum = parseFloat(this.analysis[0]['debt'])
          this.debt_rate = this.analysis[0]['debt_rate'];
          if(parseFloat(this.debt_rate) <= 49){
            this.estatusindice = "check"
          }else if(parseFloat(this.debt_rate) >= 50 && parseFloat(this.debt_rate) <= 65){
            this.estatusindice = "priority_high"
          }else{
            this.estatusindice = "close"
          }
          this.departamental_credit = this.analysis[0]['departamental_credit'];
          // this.discounts = this.analysis[0]['discounts'];
          // var discountsn =  Math.round(parseInt(this.analysis[0]['discounts'])* 100)/100;
          // this.discounts =  discountsn.toString() + "%";
          this.discounts =  (parseInt(this.analysis[0]['discounts']).toFixed(2)).toString() + "%";
          this.id = this.analysis[0]['id'];
          this.last_key = this.analysis[0]['last_key'];
          this.lowest_key = this.analysis[0]['lowest_key'];
          this.mop_key = this.analysis[0]['mop_key'];
          this.mortagage_loan = this.analysis[0]['mortagage_loan'];
          this.mortagage_loannum = parseFloat(this.analysis[0]['mortagage_loan'])
          this.net_flow = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['net_flow']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
          this.net_flownum = parseFloat(this.analysis[0]['net_flow'])
          this.other_credits = this.analysis[0]['other_credits'];
          this.overall_rate = this.analysis[0]['overall_rate'];
          this.payment_capacity = this.analysis[0]['payment_capacity'];
          if(parseFloat(this.payment_capacity) <= 50){
            this.estatuspayment = "check"
          }else if(parseFloat(this.payment_capacity) >= 51 && parseFloat(this.payment_capacity) >= 65){
            this.estatuspayment = "priority_high"
          }else{
            this.estatuspayment = "close"
  
          }
  
  
          this.previus_credit = this.analysis[0]['previus_credit'];
          this.report_date = this.analysis[0]['report_date'];
          this.total_amount = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['total_amount']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
          this.total_cost = this.analysis[0]['total_cost'];
          this.total_debt = this.analysis[0]['total_debt'];
          this.egresos_netos = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['monthly_expenses']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
          this.egresos_netosnum = parseFloat(this.analysis[0]['monthly_expenses'])
          this.creditos_LPnum = this.creditos_LPnum + this.mortagage_loannum + this.car_creditnum
          if(parseFloat(this.discounts) > 30){
            this.estatus1 = "close"
          }else{
            this.estatus1 = "check"
          }
          this.creditos_LP = this.formatNumber(this.esNulo(this.creditos_LPnum.toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
        }else {
          console.log("NO TIENE ANALISIS")
        }
  
      })
  
      this.creditosService.tiene_buro(rowData.customer).subscribe(buro => {
        this.buroStatus = buro.status;
        if (this.buroStatus){
          this.buro = buro.credit_bureau;
          // console.log("BURO")
          // console.log(this.buro['bureau_report']['respuesta']['persona']['nombre']['rfc'])
          if(!this.buro['bureau_info']){
            this.fechaReporte = this.buro['bureau_report']['respuesta']['persona']['hawkAlertConsulta'][0]['fechaReporte'];
            this.rfcBC = this.buro['bureau_report']['respuesta']['persona']['nombre']['rfc'];
            this.saldosVencidos = this.buro['bureau_report']['respuesta']['persona']['resumenReporte'][0]['totalSaldosVencidosPagosFijos']
            this.calificacionBC = this.buro['bureau_report']['respuesta']['persona']['scoreBuroCredito'][0]['valorScore']
            console.log("this.buro['bureau_report']['respuesta']['persona']['cuentas']")
            console.log(this.buro['bureau_report']['respuesta']['persona']['cuentas'])
            this.resumen_creditos = this.buro['bureau_report']['respuesta']['persona']['cuentas']
          }else{
            this.fechaReporte = this.buro['bureau_report']['results'][0]['updatedAt'];
            this.rfcBC = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['Nombre']['RFC'];
            this.saldosVencidos = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['ResumenReporte']['ResumenReporte'][0]['TotalSaldosVencidosPagosFijos']
            this.calificacionBC = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['ScoreBuroCredito']['ScoreBC'][0]['ValorScore']
            this.resumen_creditos = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['Cuentas']['Cuenta']
          }
  
          this.pdf = this.buro['extra1']
          this.urlburo = `https://docs.google.com/viewer?url=${this.pdf}&embedded=true`
  
          if(this.calificacionBC <= 550){
            this.estatusburo = 'close'
            // this.estatusburo = 'priority_high'
          }else if(this.calificacionBC >= 551 && this.calificacionBC <=650){
            this.estatusburo = 'priority_high'
          }else{
            this.estatusburo = 'check'
          }
          this.creditos_buro = this.get_ur_credits(this.resumen_creditos)
        }else {
          // stepBuro
          console.log("NO TIENE BURO")
          // document.getElementById('guardarAnalisisBtn').setAttribute("disabled", "disabled");
  
        }
  
      });
      
      this.reportesService.getRegistrationInfo(rowData.id).subscribe(info => {
        this.datosEmpleado = info[0];
        this.extra_incomes = this.datosEmpleado['extra_income'];
        this.extra_deductions = this.datosEmpleado['extra_deductions'];
        this.detail_extra_income = JSON.parse(this.datosEmpleado['detail_extra_income']);
        this.detail_extra_deductions = JSON.parse(this.datosEmpleado['detail_extra_deductions']);
        this.datosEmpleado['destino'] = customer.destino; console.log(this.datosEmpleado)
        this.datosEmpleado['dependientes'] = parseInt(this.datosEmpleado['senior_dependents']) + parseInt(this.datosEmpleado['minior_dependents'])
        this.datosEmpleado['martial_status_value'] = this.maritalStatus.find(m => m.key == this.datosEmpleado['martial_status']).value;
        this.datosEmpleado['fiscal_regime_value'] = this.regimen_fiscal2.find(r => r.key == this.datosEmpleado['fiscal_regime']).value;
        this.datosEmpleado['business_name'] = rowData.customer.business_name;
        if(this.datosEmpleado['salary_period'].toUpperCase() == 'QUINCENAL'){
          this.datosEmpleado['month_salary'] = ((parseFloat(this.esNulo(this.datosEmpleado['salary'])) + parseFloat(this.esNulo(this.datosEmpleado['ontime_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['assist_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['food_vouchers'])) ) * 2).toFixed(2);
        }else if(this.datosEmpleado['salary_period'].toUpperCase() == 'SEMANAL'){
          this.datosEmpleado['month_salary'] = ((parseFloat(this.esNulo(this.datosEmpleado['salary'])) + parseFloat(this.esNulo(this.datosEmpleado['ontime_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['assist_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['food_vouchers'])) ) * 4.33).toFixed(2);
        }
        let ingresos_mensuales_y_otros_ingresos = parseFloat(this.esNulo(this.datosEmpleado['month_salary'])) + parseFloat(this.esNulo(this.datosEmpleado['other_income']));
        this.ingresos_netos = this.formatNumber(this.esNulo(ingresos_mensuales_y_otros_ingresos.toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
        this.ingresos_netosnum = ingresos_mensuales_y_otros_ingresos;
        this.getDocuments(rowData.customer.id_contribuyente);
      });
    }

  }

  onStepBuro(){
    this.stepBuro = false;
  }

  cleanURL(oldURL: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }

  async armarCreditosAsync(credit) {
    if (credit.gov_customer_id) {
      const resp = await this.usuarioService.getGovCustomer(credit.gov_customer_id).toPromise();
      this.armarInfo(credit, resp['data'], 'gov');
      return;
    }

    const status = this.credit_status.find(s => s.key == credit.status);
    credit.status = status?.value || credit.status;

    const customer = await this.creditosService.traer_customer(credit.id).toPromise();
    const cus = customer[0];
    this.armarInfo(credit, cus);
  }

  armarCreditos(credit){
    if(credit.gov_customer_id){
      this.usuarioService.getGovCustomer(credit.gov_customer_id).subscribe(resp => {
        this.armarInfo(credit, resp['data'], 'gov');
      });
      return;
    }
    let status = this.credit_status.find(s => s.key == credit.status);
    credit.status = status.value;
    this.creditosService.traer_customer(credit.id).subscribe(customer => {
      let cus = customer[0];
      this.armarInfo(credit, cus)
    })
  }

  armarInfo(credit, cus, type = 'customer'){
    var tipo_contribuyente = cus.tipo_contribuyente;
    var status_cliente = cus.status_cliente;
    credit.nombre_empleado = cus.nombre_cliente;
    if(type == 'gov'){
      tipo_contribuyente = cus['attributes'].fiscal_regime;
      status_cliente = 'AC';
      var gov_customers = cus['relations']['gov_customers'][0]['attributes'];
      credit.nombre_empleado = `${gov_customers['first_name']} ${gov_customers['last_name']} ${gov_customers['second_last_name']}` 
      cus['salary_period'] = gov_customers['salary_period'].toUpperCase();
      this.awsService.getCompanyes().subscribe(resp => {
        this.companies = resp;
        credit.compañia = this.companies.find(c => c.id == gov_customers['company_id']).business_name;
      })
    }
    
      if(cus.pf_regimen_fiscal != null){
        let rf = this.regimen_fiscal.find(r => cus.pf_regimen_fiscal == r.key);
        cus.pf_regimen_fiscal = rf.value;
      }else if(cus.pm_regimen_fiscal != null){
        let rf = this.regimen_fiscal.find(r => cus.pm_regimen_fiscal == r.key);
        cus.pm_regimen_fiscal = rf.value;
      }
      let tc = this.regimen_fiscal_contribuyente.find(c => tipo_contribuyente == c.key);
      cus.tc = cus.tipo_contribuyente;
      cus.tipo_contribuyente = tc.value;
      let cs = this.client_status.find(s => status_cliente == s.key);
      cus.status_cliente = cs.value;
      credit.customer = cus;
      let pp = this.paymentPeriods.find(p => p.id === credit.payment_period_id);
      credit.payment_period = pp.key;
      let terms = this.terms.filter(t => t.term_type.toUpperCase() === cus.salary_period.toUpperCase());
      terms.push({id:'0', key:'Pago Fijo'});
      credit.terms = terms;
      if(credit.term_id == null){
        credit.term_id = "0";
        credit.term = 'Pago fijo';
      }else{
        let term = terms.find(t => t.id == credit.term_id);
        if(term != undefined){
          credit.term = term.key;
        }else{
          credit.term_id = "0";
          credit.term = 'Pago fijo';
        }
      }
      if(credit.status == 'PA'){
        credit.status = 'PENDIENTE APROBACION';
      }
      this.creditos.push(credit);
  }

  cambiarFiltro(status){
    this.filtro = status;
    /*setTimeout(() => {
      document.getElementById('reset').click();
    }, 1800);*/
    this.ngOnInit();
  }

  assignAnalyst(rowData, analystId) {
    if (!analystId) return;
    const analyst = this.analystUsers.find(a => a.id === analystId);
    swal2.fire({
      title: '¿Asignar analista?',
      html: `Se asignará a <b>${analyst?.name?.toUpperCase()}</b> como analista de este crédito. Esta acción no se puede deshacer.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, asignar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.creditosService.updateCredit(rowData.id, { customer_credit: { analyst_user_id: analystId } }).subscribe(resp => {
          rowData.analyst_user = analyst;
          swal2.fire('Éxito', 'Analista asignado correctamente', 'success');
        }, err => {
          swal2.fire('Error', 'No se pudo asignar el analista', 'error');
        });
      }
    });
  }

  guardar(rowData){
    console.log(rowData); return
    localStorage.setItem('customer_credit', rowData.id);
  }

  // Ajusta la fecha de inicio del credito GPA a HOY. Herramienta de soporte: solo aplica a
  // creditos GPA (gov_customer_id null) en estatus PA. El backend regenera el credito con
  // fecha de hoy, deja el original en historico y registra la bitacora con el usuario en sesion.
  ajustarFechaCredito(rowData){
    const hoy = new Date();
    const dia = ('0' + hoy.getDate()).slice(-2);
    const mes = ('0' + (hoy.getMonth() + 1)).slice(-2);
    const anio = hoy.getFullYear();
    const fechaHoy = `${dia}/${mes}/${anio}`;

    const folio = rowData.credit_folio || 'N/D';
    const nombre = rowData.nombre_empleado || 'N/D';
    const fechaActual = rowData.start_date ? new DatePipe('en-US').transform(rowData.start_date, 'dd/MM/yyyy') : 'N/D';

    swal2.fire({
      title: '¿Ajustar fecha de inicio?',
      html: `<div style="text-align: left; font-size: 14px;">`
        + `<b>Folio:</b> ${folio}<br>`
        + `<b>Empleado:</b> ${nombre}<br>`
        + `<b>Fecha de inicio actual:</b> ${fechaActual}<br>`
        + `<b>Nueva fecha de inicio:</b> ${fechaHoy}<br><br>`
        + `Se regenerará el crédito con fecha de inicio de hoy (${fechaHoy}) ¿Deseas continuar?`
        + `</div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar ajuste',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (!result.isConfirmed) { return; }

      swal2.fire({
        title: 'Procesando petición',
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => { swal2.showLoading(); }
      });

      const user_id = localStorage.getItem('uid');
      this.creditosService.adjustGpaCreditDate(rowData.id, user_id).subscribe(resp => {
        swal2.fire('Éxito', 'La fecha del crédito se ajustó correctamente.', 'success').then(() => {
          this.ngOnInit();
        });
      }, err => {
        console.log('err ajustarFechaCredito', err);
        try {
          swal2.fire('Atención', err.error.errors[0], 'warning');
        } catch {
          swal2.fire('Atención', 'No fue posible ajustar la fecha del crédito.', 'warning');
        }
      });
    });
  }

  rechazar(id,nota){
    this.creditosService.updateCredit(id, {status: 'RZ', rejection_note: nota}).subscribe(resp => {
      swal2.fire({
        title: 'Exito', 
        text: 'Crédito rechazado', 
        icon: 'success',
        showConfirmButton: true,
        allowOutsideClick: false
      }).then(res => {
        this.ngOnInit();
      });
    }, err => {
      console.log(err);
      swal2.fire('Error', 'Algo salió mal', 'info');
    })
  }

  confirmarRechazo(id,nombre){
    swal2.fire({
      title: 'Está a punto de rechazar la solicitud de ' + nombre ,
      text: "Motivo de rechazo",
      input: 'text',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, rechazar crédito',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      inputPlaceholder: "Introduzca el motivo de rechazo",
      inputValidator: (value) => {
        if (!value) {
          return 'Favor de ingresar un motivo!'
        }
      }      
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value === "") {
          swal2.fire("Precaucion", "Favor de agregar un motivo de rechazo", "warning");
          return false
        }
        this.rechazar(id,result.value)
      }
    })
  }

  crearProject(info){
    swal2.showLoading()
    this.creditosService.updateCredit(info.id, {status: 'RE'}).subscribe(resp => {
      let date = new Date();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let start_date;

      if(month < 10){
        start_date =  `${year}-0${month}-${day}`;
      }else{
        start_date = `${year}-${month}-${day}`;
      }
      const params = {};
      const customer_credit = {
        total_requested: info.total_requested,
        status: 'PR',
        start_date: start_date,
        customer_id: info.customer_id,
        rate: info.rate,
        user_id: localStorage.getItem('uid'),
        iva_percent: info.iva_percent,
        currency: info.currency
        // term_id: info.term_id,
        // payment_period_id: info.payment_period_id,
      }
      if(info.term_id === '0'){
        params['payment_amount'] = info.fixed_payment;
      }else {
        customer_credit['term_id'] = info.term_id;
        // params['payment_period_id'] = info.payment_period_id;
      }
      if(info.hasOwnProperty('anualidad')){
        customer_credit['anuality'] = info.anualidad;
        if(info.hasOwnProperty('anuality_date')){
          customer_credit['anuality_date'] = info.anuality_date;
        }else{
          swal2.fire('Faltan datos', 'Seleccione una fecha para el pago de la anualidad', 'info');
          return;
        }
      }
      params['customer_credit'] = customer_credit;
      // console.log(params);
      // SE ENVIAN LOS CORREOS AL COMITE Y EMPRESA PARA QUE FIRMEN/ACEPTEN EL CREDITO
      this.creditosService.customerCredit(params)
        .subscribe(resp => {
          swal2.fire({
            title: 'Operación correcta', 
            text: 'Propuesta enviada', 
            icon: 'success',
            allowOutsideClick: false,
            showConfirmButton: true
          }).then(resp => {
            if(resp.value){
              this.ngOnInit();

            }
          });
        }, err => {
          console.log('err', err);
          try{
            swal2.fire('Hubo un problema', err.error.errors[0], 'info');
          }catch{
            swal2.fire('', 'Hubo un problema', 'info');
          }
        })
    }, err => {
      console.log('error', err);
      swal2.fire('', 'Hubo un problema', 'info');
    })
  }

  //------------------------------------------------------------

  get_ur_credits(credits){ 
    var ur_credits = {mop: 'UR', cuentas_abiertas: 0, limite_abiertas: 0, maximo_abiertas: 0, saldo_actual: 0,
                saldo_vencido: 0, pago_realizar: 0, cuentas_cerradas: 0, limite_cerradas: 0, maximo_cerradas: 0,
                saldo_cerradas: 0, monto_cerradas: 0}

    var credits_01 = {mop: '01',cuentas_abiertas: 0, limite_abiertas: 0, maximo_abiertas: 0, saldo_actual: 0, saldo_vencido: 0,
    pago_realizar: 0, cuentas_cerradas: 0, limite_cerradas: 0, maximo_cerradas: 0, saldo_cerradas: 0,
    monto_cerradas: 0}


    var all_credits = []


    credits.forEach(credit =>{
      if(credit['fechaCierreCuenta'] && credit['formaPagoActual'] === 'UR'){
        ur_credits['cuentas_cerradas'] += 1
        ur_credits['limite_cerradas'] += parseInt(credit['limiteCredito'] ? credit['limiteCredito'] : 0)
        ur_credits['maximo_cerradas'] += parseInt(credit['creditoMaximo'])
        ur_credits['saldo_cerradas'] += parseInt(credit['saldoActual'])
        ur_credits['monto_cerradas'] += parseInt(credit['montoPagar'])
      }else if (credit['fechaCierreCuenta'] && credit['formaPagoActual'] === '01'){
        credits_01['cuentas_cerradas'] += 1
        credits_01['limite_cerradas'] += parseInt(credit['limiteCredito'] ? credit['limiteCredito'] : 0)
        credits_01['maximo_cerradas'] += parseInt(credit['creditoMaximo'])
        credits_01['saldo_cerradas'] += parseInt(credit['saldoActual'])
        credits_01['monto_cerradas'] += parseInt(credit['montoPagar'])
      }else if (!credit['fechaCierreCuenta'] && credit['formaPagoActual'] === 'UR'){
        ur_credits['cuentas_abiertas'] += 1
        ur_credits['limite_abiertas'] += parseInt(credit['limiteCredito'] ? credit['limiteCredito'] : 0)
        ur_credits['maximo_abiertas'] += parseInt(credit['creditoMaximo'])
        ur_credits['saldo_actual'] += parseInt(credit['saldoActual'])
        ur_credits['saldo_vencido'] += parseInt(credit['SaldoVencido'])
        ur_credits['pago_realizar'] += parseInt(credit['montoPagar'])
      }else if (!credit['fechaCierreCuenta'] && credit['formaPagoActual'] === '01'){
        credits_01['cuentas_abiertas'] += 1
        credits_01['limite_abiertas'] += parseInt(credit['limiteCredito'] ? credit['limiteCredito'] : 0)
        credits_01['maximo_abiertas'] += parseInt(credit['creditoMaximo'])
        credits_01['saldo_actual'] += parseInt(credit['saldoActual'])
        credits_01['saldo_vencido'] += parseInt(credit['SaldoVencido'])
        credits_01['pago_realizar'] += parseInt(credit['montoPagar'])
      }
    });

    all_credits.push(ur_credits)
    all_credits.push(credits_01)

    return all_credits
  }

  esNulo (dato){
    if(dato == null){
      return 0;
    }else{
      return dato;
    }
  }

  showModalf(rowData) {
    var id = rowData.id;
    this.creditoSeleccionadoTabla = rowData;
    this.payments = [];
    this.creditosService.customerCreditPayments(id).subscribe(pays => {
      pays['data'].forEach(p => {
/*         this.payments.push(p['attributes']); */
          const payment = p['attributes'];/* borrar */
          if(payment.commission == null ){
            payment.commission = 0
          }
          if(payment.insurance == null ){
            payment.insurance = 0
          }
/*           payment.insurance = 100; // Valor fijo de seguro
          payment.commission = 50; // Valor fijo de comisión */
          this.payments.push(payment);/* borrar */
      });
    });
    
    this.showModal = true; // Show-Hide Modal Check
  }

  hideModal() {
    this.showModal = false;
  }  

  show(datarow) {
    this.showModal = true; // Show-Hide Modal Check
    // console.log(datarow);
    this.idsolicitud = datarow.id;
    this.foliosolicitud = datarow.folio;
    // return '2';
  }

  hideds() {
    this.showmodalds = false;
    this.analysisStatus = false;
  }  

  formatNumber(n) {
    // format number 1000000 to 1,234,567
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  estadoCivil(estado){
    if(estado == 'SO'){
      return 'Soltero';
    }else if(estado == 'CA'){
      return 'Casado';
    }
  }

  excelSiac(){
    var PACredits = [];
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let start_date;

    if(month < 10){
      start_date =  `${day}0${month}${year}`;
    }else{
      start_date = `${day}${month}${year}`;
    }
    this.creditos.forEach(item => {
      var base = {};
      if(item.gov_customer_id && item.gov_customer_id != null){
        base = {
          'Apellido Paterno': item.customer.attributes.last_name || '',
          'Apellido Materno': item.customer.attributes.second_last_name || '',
          'Nombres': item.customer.attributes.first_name || '',
          'Dirección (Calle)': item.customer.relations.contributor_addresses[0].attributes.street || '',
          'No. Exterior' : item.customer.relations.contributor_addresses[0].attributes.external_number || '',
          'No. Interior' : item.customer.relations.contributor_addresses[0].attributes.apartment_number || '',
          'C.P.' : item.customer.relations.contributor_addresses[0].attributes.postal_code || '',
          'Municipio' : item.customer.relations.municipalities[0].attributes.name || '',
          'Colonia' : item.customer.relations.contributor_addresses[0].attributes.suburb || '',
          'Entidad Federativa de nacimiento' : item.customer.relations.states[0].attributes.name || '',
          'Fecha de nacimiento' : item.customer.attributes.birthdate || '',
          'RFC' : item.customer.attributes.rfc || '',
          'CURP' : item.customer.attributes.curp || '',
          'Estado Civil' : this.estadoCivil(item.customer.attributes.martial_status) || '',
          'TIPO ID' : item.customer.attributes.id_type || '',
          'Folio ID ' : item.customer.attributes.identification || '',
        }
      }else{
        base = {
          'Apellido Paterno': item.customer.apellido_paterno || '',
          'Apellido Materno': item.customer.apellido_materno || '',
          'Nombres': item.customer.nombre || '',
          'Dirección (Calle)': item.customer.calle || '',
          'No. Exterior' : item.customer.numero_exterior || '',
          'No. Interior' : item.customer.numero_apartamento|| '',
          'C.P.' : item.customer.codigo_postal || '',
          'Municipio' : item.customer.municipio || '',
          'Colonia' : item.customer.suburb || '',
          'Entidad Federativa de nacimiento' : item.customer.estado || '',
          'Fecha de nacimiento' : item.customer.pf_fecha_nacimiento || '',
          'RFC' : item.customer.pf_rfc || '',
          'CURP' : item.customer.pf_curp || '',
          'Estado Civil' : this.estadoCivil(item.customer.pf_estado_civil) || '',
          'TIPO ID' : item.customer.pf_tipo_identificacion || '',
          'Folio ID ' : item.customer.pf_numero_identificacion || '',
        }
      }
      PACredits.push(base);
    })
    const readOpts = {
      cellText: false, 
      cellDates: true,
    };

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(PACredits, readOpts);
    const wb: XLSX.WorkBook = XLSX.utils.book_new(); 
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Generales_SIAC_${start_date}.xlsx`, readOpts);
  }

  exportexcel() {
    this.fileName = "Layout" + '.xlsx';
    const Excel = require('exceljs');
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('base');
    let titulo = ['PLANTILLA DE PAGOS PROGRAMADOS']
    worksheet.addRow(titulo);
    worksheet.mergeCells(1, 1, 1, 2);
    let pagos = ['No. De pagos', this.payments.length]
    worksheet.addRow(pagos);
    let header=['Fecha de pago', 'Capital'];
    worksheet.addRow(header);
    for (const prop in this.payments) {
      var datePipe = new DatePipe('en-US');
      var fecha = datePipe.transform(this.payments[prop].payment_date, 'dd/MM/yyyy');
      worksheet.addRow([
        // this.payments[prop].pay_number,
        // new Date(this.payments[prop].payment_date).toLocaleDateString('en-US'),
        fecha,
        this.payments[prop].capital
      ]);
    } 
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: '.xlsx' });
      const file = blob;
      fs.saveAs(blob, this.fileName);
  });
  }

}
